import { render, staticRenderFns } from "./approveHistory.vue?vue&type=template&id=4f1d2228&"
import script from "./approveHistory.vue?vue&type=script&lang=js&"
export * from "./approveHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports